import axios from 'axios';
import { BASE_PATH_API } from 'constants/env';

export async function patchReview({body, id}) {
  try {
    const { data } = await axios({
      url: `${BASE_PATH_API}/gift-table/v1/review/${id}`,
      method: 'PATCH',
      data: body
    });
    return data.data;
  } catch (error) {
    console.log(error);
  }
}
